/**
 * @param html
 * @returns {string}
 */
export const escapeHtml = (html) => {
	return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};

/**
 * 문자열 내 url 패턴을 자동으로 a 태그로 교체한다.
 * @param {string} str
 * @returns {string}
 */
export const activateUrlAutomatically = (str) => {
	return str.replace(
		/(https?:)?(\/\/)?(((([a-z가-힣\d](-*[a-z가-힣\d])*)\.)+[a-z가-힣]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z가-힣\d%_.~+]*)*(\?[;&a-z가-힣\d%_.~+=-]*)?(#[-a-z가-힣\d_]*)?)/gi,
		'<a href="$1//$3" target="_blank" rel="noopener">$&</a>'
	);
};

/**
 * 이미지 썸네일 URL을 생성한다.
 * @param {string} url
 * @param {number} width
 * @param {number} height
 * @param {string} cropOption
 * @returns {string}
 */
export const getThumbnailUrl = (url, width, height, cropOption) => {
	const host = url.match(/beta\.(daum|kakao)cdn\.net/)
		? 'img1-beta.daumcdn.net'
		: 'img1.daumcdn.net';

	return `//${host}/thumb/${cropOption}${width}x${height}/?fname=${encodeURIComponent(url)}`;
};

export const login = (url) => {
	const returnUrl = url || document.URL;
	window.location.href = `${CAFEAPP.LOGIN_URL}/accounts/loginform.do?mobilefull=1&url=${encodeURIComponent(returnUrl)}`;
};

/**
 * 비로그인 처리용 HOF
 * @param {function} cb
 * @returns {Promise<*>}
 */
export const loginIfPermissionDenied = async (cb) => {
	try {
		return await cb();
	} catch (e) {
		if (e.response?.status === 401) {
			login();
		} else {
			throw e;
		}
	}
};
